import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Facebook, Instagram, MapPin, Phone, Calendar } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-gray-800 to-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Logo and Description */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="md:col-span-2"
          >
            <div className="flex items-center mb-4">
              <div className="relative">
                <div className="bg-gradient-to-r from-primary-400 to-secondary-400 rounded-full p-3 mr-4">
                  <span className="text-2xl font-black text-white">SD</span>
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold">Superdiena</h3>
                <p className="text-gray-400">Ziemas piedzīvojums Viļānos</p>
              </div>
            </div>


            <div className="flex space-x-4">
              <motion.a
                href="mailto:ezaurins@pm.me"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors text-white"
              >
                <Mail size={18} />
              </motion.a>
              <motion.a
                href="#"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-500 transition-colors text-white"
              >
                <Facebook size={18} />
              </motion.a>
              <motion.a
                href="#"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-pink-500 transition-colors text-white"
              >
                <Instagram size={18} />
              </motion.a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="text-lg font-bold mb-4">Ātras saites</h4>
            <ul className="space-y-2">
              {[
                { name: 'Sākums', href: '#hero' },
                { name: 'Pieteikšanās', href: '#registration' },
                // ... other links
                { name: 'Programma', href: '#program' },
                { name: 'Kontakti', href: '#contact' }
              ].map((link, index) => (
                <li key={index}>
                  <motion.a
                    href={link.href}
                    whileHover={{ x: 5 }}
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer block"
                  >
                    {link.name}
                  </motion.a>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="text-lg font-bold mb-4">Kontakti</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <span className="mr-3 text-primary-400"><MapPin size={18} /></span>
                <div>
                  <p className="text-gray-300 text-sm">"Dadzis", Viļāni</p>
                  <p className="text-gray-300 text-sm">Mežniecība, Teveņāni</p>
                </div>
              </div>
              <div className="flex items-center">
                <span className="mr-3 text-secondary-400"><Phone size={18} /></span>
                <p className="text-gray-300 text-sm">+371 24 904 140</p>
              </div>
              <div className="flex items-center">
                <span className="mr-3 text-accent-400"><Mail size={18} /></span>
                <p className="text-gray-300 text-sm">ezaurins@pm.me</p>
              </div>
              <div className="flex items-center">
                <span className="mr-3 text-green-400"><Calendar size={18} /></span>
                <div>
                  <p className="text-gray-300 text-sm">26. decembris, 2025</p>
                  <p className="text-gray-300 text-sm">11:00 - 21:00</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Newsletter Signup 
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="bg-gray-700 rounded-2xl p-6 mb-8"
        >
          <div className="text-center mb-4">
            <h4 className="text-xl font-bold mb-2">Saņem jaunumus</h4>
            <p className="text-gray-300 text-sm">
              Pierakstieties, lai saņemtu informāciju par nākamajām nometnēm un pasākumiem
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Tavs e-pasts"
              className="flex-1 px-4 py-3 rounded-lg bg-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
            />
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-6 py-3 bg-gradient-to-r from-primary-500 to-secondary-500 text-white font-medium rounded-lg hover:from-primary-600 hover:to-secondary-600 transition-all"
            >
              Pierakstīties
            </motion.button>
          </div>
        </motion.div>*/}

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="border-t border-gray-700 pt-8"
        >
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              <p>&copy; {currentYear} Superdiena. Visas tiesības aizsargātas.</p>
            </div>
            <div className="flex space-x-6 text-sm">
              <motion.a
                href="#"
                whileHover={{ scale: 1.05 }}
                className="text-gray-400 hover:text-white transition-colors"
              >
                Privātuma politika
              </motion.a>
              <motion.a
                href="#"
                whileHover={{ scale: 1.05 }}
                className="text-gray-400 hover:text-white transition-colors"
              >
                Lietošanas noteikumi
              </motion.a>
              <motion.a
                href="#"
                whileHover={{ scale: 1.05 }}
                className="text-gray-400 hover:text-white transition-colors"
              >
                Sīkdatnes
              </motion.a>
            </div>
          </div>
        </motion.div>

        {/* Floating Elements */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <motion.div
            animate={{ y: [0, -20, 0], rotate: [0, 10, 0] }}
            transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
            className="absolute top-10 right-10 w-16 h-16 bg-primary-400 rounded-full opacity-10"
          />
          <motion.div
            animate={{ y: [0, 20, 0], rotate: [0, -10, 0] }}
            transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
            className="absolute bottom-20 left-20 w-12 h-12 bg-secondary-400 rounded-full opacity-10"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
